import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';

const RoleLockedModal = ({ roleLockedInfo, onClose }) => {
  if (!roleLockedInfo) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-xs animate-in fade-in duration-200">
      <motion.div
        initial={{ scale: 0.92, opacity: 0, y: 15 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        className="bg-white rounded-3xl max-w-md w-full p-6 sm:p-7 shadow-2xl border border-slate-200 space-y-5 text-center relative overflow-hidden"
      >
        <div className="w-16 h-16 rounded-2xl bg-teal-50 border border-teal-200/90 text-[#067978] flex items-center justify-center mx-auto shadow-xs">
          <Lock size={30} />
        </div>

        <div className="space-y-2">
          <h3 className="text-xl font-bold text-slate-900 tracking-tight">
            Team Role Account Locked
          </h3>
          <p className="text-xs sm:text-sm text-slate-600 leading-relaxed">
            Your role-based team account is currently locked because your organization's subscription has expired or changed.
          </p>
        </div>

        <div className="p-4 bg-teal-50/60 border border-teal-200/90 rounded-2xl text-left space-y-2">
          <div className="flex items-center gap-2 text-xs font-bold text-[#067978]">
            <span className="w-2 h-2 rounded-full bg-[#067978]" />
            Enterprise Plan Required
          </div>
          <p className="text-xs text-slate-600 leading-relaxed">
            Multi-user team logins are an <strong>Enterprise Plan</strong> feature. Please contact your organization administrator (agency owner) to renew or upgrade to the Enterprise Plan to reactivate your login.
          </p>
        </div>

        <button
          type="button"
          onClick={onClose}
          className="w-full py-3 bg-[#067978] hover:bg-[#05605f] text-white font-bold text-sm rounded-xl shadow-md transition-all active:scale-95 cursor-pointer"
        >
          Understood / Back to Login
        </button>
      </motion.div>
    </div>
  );
};

export default RoleLockedModal;
